
export const Products = [
   {
      id: 1,
      name: 'The best HR Management System in Cambodia',
      description:
         "AKAS's Human Resource Management System is an intuitive, user-friendly, multilingual, web-based application accessible from various devices, including PCs, laptops, Macs, and tablets, using browsers like Internet Explorer, Firefox, Chrome, and Safari.s",

      images: [
         '/images/products/hr-db-1.png',
         '/images/products/hr-db-2.png',
         '/images/products/hr-employee-list.png',
         '/images/products/hr-employee-form.png',
         '/images/products/hr-employment.png',
         '/images/products/hr-employment-history.png',
         '/images/products/hr-leave-request.png',
         '/images/products/hr-mypayslip.png',
         '/images/products/hr-approval-workflow.png',
      ],
      backgroundImage: '/images/backgrounds/hrms.jpg',
      mainFeatures: [
         {
            icon: '💻',
            title: 'Online Self-Service',
            description:
               'Upon logging in, employees can access a dashboard offering: Links to update profiles, view work schedules, request leave, submit resignation forms, and claim overtime. Sections for pending approvals, personal pending requests, upcoming events, new employee introductions, birthdays, current and approved leaves, personal tasks, job vacancies, and internal messaging.',
            images: [
               '/images/products/hr-ess-leaverequest.png',
               '/images/products/hr-ess-leavecancel.png',
               '/images/products/hr-ess-myleave.png',
               '/images/products/hr-ess-resignrequest.png',
               '/images/products/hr-ess-jobrequisition.png',
               '/images/products/hr-ess-mypendingrequest.png',
            ],
         },
         {
            icon: '👥',
            title: 'Recruitment',
            description:
               'Administrators can define job titles with specific requirements, descriptions, and responsibilities, and post announcements. Job vacancies are accessible via the dashboard and public website. Employees can request job requisitions, which, upon approval, can be managed by HR admins. Applicants can register and apply online.',
            images: [
               '/images/products/hr-recruit-jobtitle.png',
               '/images/products/hr-recruit-jobrequisition.png',
               '/images/products/hr-recruit-manage-applicants.png',
               '/images/products/hr-recruit-manage-applicants2.png',
               '/images/products/hr-recruit-notify-applicant.png',
               '/images/products/hr-recruit-notify-custom.png',
            ],
         },
         {
            icon: '👤',
            title: 'Personnel',
            description:
               'Comprehensive management of employee information, including IDs, emails, reporting lines, hiring dates, work units, salary details, leave quotas, and work schedules. The system handles workflows from hiring and promotions to insurance offers, awards, misconduct records, and terminations.',
            images: [
               '/images/products/hr-employee-list.png',
               '/images/products/hr-employee-form.png',
               '/images/products/hr-employment.png',
               '/images/products/hr-employment-history.png',
               '/images/products/hr-emp-printcontract.png',
            ],
         },
         {
            icon: '📅',
            title: 'Leave and Attendance',
            description:
               'Records and manages leave and attendance data for all employees. Integrates with fingerprint devices to log time in and out, facilitating detailed attendance analysis. Leave requests can be submitted by employees and approved by managers or HR admins.',
            images: [
               '/images/products/hr-leave-holiday.png',
               '/images/products/hr-leave-leavetype.png',
               '/images/products/hr-leave-workshift.png',
               '/images/products/hr-leave-records.png',
               '/images/products/hr-leave-balance.png',
               '/images/products/hr-leave-report.png',
            ],
         },
         {
            icon: '📊',
            title: 'Performance Management',
            description:
               'Establishes Key Performance Indicators (KPIs), dynamic review templates, scoring calculations, and maintains review records. Entries can be made offline by HR admins or through online review invitations.',
            images: [
               '/images/products/hr-perf-kpi.png',
               '/images/products/hr-perf-template.png',
               '/images/products/hr-perf-review.png',
            ],
         },
         {
            icon: '💰',
            title: 'Compensation (Payroll)',
            description:
               'A comprehensive payroll module integrated with the employee module. Allows employees to submit overtime claims for managerial approval. HR admins can manage pay queues and process payroll records regularly.',
            images: [
               '/images/products/hr-payroll-element.png',
               '/images/products/hr-payroll-otpolicy.png',
               '/images/products/hr-payroll-salarytax.png',
               '/images/products/hr-payroll-otpayrequest.png',
               '/images/products/hr-payroll-register.png',
               '/images/products/hr-payroll-tos.png',
               '/images/products/hr-payroll-nssf1.png',
               '/images/products/hr-payroll-nssf2.png',
               '/images/products/hr-mypayslip.png',
               '/images/products/hr-payroll-payslip.png',
            ],
         },
      ],
      meta: {
         title: 'AKAS | The best HR Management System in Cambodia',
         description:
            "AKAS's Human Resource Management System is an intuitive, user-friendly, multilingual, web-based application accessible from various devices, including PCs, laptops, Macs, and tablets, using browsers like Internet Explorer, Firefox, Chrome, and Safari. ",
         keywords:
            'HR Management System, AKAS, Human Resource Management, HRMS, HR Management, HR Management System, HR Management Software, HR Management Solution, HR Management System, HR Management System, HR Management System',
      },
      additionalFeatures: [
         {
            icon: '✓',
            title: 'Approval Workflow',
            description:
               'We have a flexible approval workflow that allows you to customize the approval process to your needs.',
         },
         {
            icon: '🌐',
            title: 'Multiple languages',
            description: 'English and Khmer (can be added more)',
         },
         {
            icon: '📁',
            title: 'Document Management',
            description: '',
         },
         {
            icon: '⚙️',
            title: 'Fully customizable',
            description: '',
         },
         {
            icon: '🔔',
            title: 'Notifications',
            description: '',
         },
         {
            icon: '📝',
            title: 'Logging',
            description: '',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Increased Efficiency',
            description:
               'Streamline HR processes, reduce paperwork, and automate repetitive tasks. Our HRMS helps HR professionals focus on strategic initiatives rather than administrative work.',
         },
         {
            number: '02',
            title: 'Better Decision Making',
            description:
               'Access real-time data and analytics to make informed HR decisions. Monitor key metrics such as employee turnover, productivity, and performance.',
         },
         {
            number: '03',
            title: 'Enhanced Employee Experience',
            description:
               'Provide self-service options for employees to manage their information, apply for leave, and access company resources, leading to higher satisfaction and engagement.',
         },
         {
            number: '04',
            title: 'Compliance Management',
            description:
               'Stay compliant with labor laws and regulations by maintaining accurate records and generating required reports automatically.',
         },
      ],
      videos: [
         {
            title: 'Flexible approval workflow',
            youtubeId: 'Rt-Zk9H0rNg',
            description: 'Design approval workflow in AKAS.',
         },
         {
            title: 'Resume Parsing Feature',
            youtubeId: '5-htzI5-TVQ',
            description:
               'See how our AI-powered resume parsing feature works in action.',
         },
         {
            title: 'HRMS Demo in Khmer',
            youtubeId: 'sOLBiaDt1IE',
            description: 'AKAS HRMS Demo in Khmer',
         },
         {
            title: 'Customization feature',
            youtubeId: 'RlB4MXPjYXs',
            description: 'Customization feature Demo',
         },
      ],
   },
   {
      id: 2,
      name: 'Customer Relationship Management',
      description:
         "AKAS's comprehensive CRM solution helps businesses of all sizes streamline customer interactions, improve sales processes, and build lasting relationships. Our intuitive, cloud-based platform provides a 360° view of your customers, enabling your team to deliver exceptional service at every touchpoint.",
      images: ['/images/products/crm.jpeg'],
      backgroundImage: '/images/products/crm.jpeg',
      mainFeatures: [
         {
            icon: '🔄',
            title: 'Contact Management',
            description:
               'Centralize and organize all your customer data in one place. Track customer interactions, contact details, communication history, and preferences to build stronger customer relationships.',
         },
         {
            icon: '📊',
            title: 'Sales Pipeline Management',
            description:
               'Visualize and manage your entire sales process from lead generation to closing deals. Track opportunities, monitor sales activities, and forecast revenue with customizable sales funnels and pipelines.',
         },
         {
            icon: '📱',
            title: 'Omnichannel Communication',
            description:
               'Engage with customers across multiple channels including email, phone, social media, and chat. All communications are integrated and recorded, ensuring consistent messaging and seamless customer experience.',
         },
         {
            icon: '📝',
            title: 'Case Management',
            description:
               'Efficiently handle customer inquiries, issues, and support requests with automated case routing, prioritization, and resolution tracking. Improve response times and customer satisfaction.',
         },
         {
            icon: '📈',
            title: 'Reporting & Analytics',
            description:
               'Gain valuable insights with comprehensive reporting tools. Analyze customer data, sales performance, support metrics, and team productivity with customizable dashboards and real-time reports.',
         },
         {
            icon: '🤖',
            title: 'Automation & Workflows',
            description:
               'Streamline repetitive tasks and standardize processes with customizable workflows and automation rules. Improve efficiency and ensure consistent customer experiences throughout their journey.',
         },
      ],
      meta: {
         title: 'AKAS | The best CRM, Sales and Revenues, Purchases and Expenses, and Accounting in Cambodia',
         description:
            "AKAS's comprehensive CRM solution helps businesses of all sizes streamline customer interactions, improve sales processes, and build lasting relationships.",
         keywords:
            'CRM, Customer Relationship Management, AKAS, Customer Management, Sales Pipeline, Automation, Case Management',
      },
      additionalFeatures: [
         {
            icon: '🌐',
            title: 'Multiple languages',
            description: 'English and Khmer (additional languages available)',
         },
         {
            icon: '📱',
            title: 'Mobile Access',
            description: 'Access your CRM anytime, anywhere',
         },
         {
            icon: '🔌',
            title: 'API Integration',
            description: 'Connect with your existing business tools',
         },
         {
            icon: '🔒',
            title: 'Secure Data',
            description: 'Enterprise-grade security protocols',
         },
         {
            icon: '⚙️',
            title: 'Customizable',
            description: 'Tailor the system to your specific needs',
         },
         {
            icon: '📊',
            title: 'Business Intelligence',
            description: 'Advanced data visualization tools',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Increased Sales Efficiency',
            description:
               'Streamline your sales process, reduce administrative tasks, and focus on closing deals. Our CRM helps sales teams prioritize leads, track interactions, and manage opportunities effectively.',
         },
         {
            number: '02',
            title: 'Enhanced Customer Experience',
            description:
               'Provide personalized service with access to complete customer history and preferences. Respond faster to inquiries and resolve issues promptly with streamlined workflows.',
         },
         {
            number: '03',
            title: 'Data-Driven Decisions',
            description:
               'Gain valuable insights from comprehensive analytics and reporting tools. Understand customer behavior, identify trends, and make informed business decisions based on real-time data.',
         },
         {
            number: '04',
            title: 'Improved Team Collaboration',
            description:
               'Break down silos between departments with a centralized platform. Ensure consistent communication and information sharing across sales, marketing, and customer service teams.',
         },
      ],
   },
   {
      id: 3,
      name: 'Insurance Management System',
      description:
         "AKAS's Insurance Management System is a comprehensive solution designed to streamline insurance operations, improve customer service, and increase operational efficiency.",
      images: ['/images/products/insurance.jpeg'],
      backgroundImage: '/images/products/insurance.jpeg',
      mainFeatures: [
         {
            icon: '📊',
            title: 'Policy Management',
            description:
               'Comprehensive policy management system for tracking all insurance policies, their details, coverage, and renewal dates. Easily search, filter, and generate reports on your policy portfolio.',
         },
         {
            icon: '👥',
            title: 'Client Management',
            description:
               'Maintain a complete database of all clients, including personal information, contact details, policy history, and communication logs. Build stronger relationships with detailed client profiles.',
         },
         {
            icon: '📝',
            title: 'Claims Processing',
            description:
               'Streamline the entire claims process from submission to resolution. Track claim status, manage documentation, and ensure timely processing with automated workflows and notifications.',
         },
         {
            icon: '📅',
            title: 'Renewal Management',
            description:
               'Automatically track policy renewal dates and set up reminders for clients and agents. Generate renewal quotes and manage the entire renewal process efficiently.',
         },
         {
            icon: '📱',
            title: 'Mobile Access',
            description:
               'Access your insurance management system on-the-go through our responsive mobile application. View client information, policy details, and claims status from anywhere, anytime.',
         },
         {
            icon: '📈',
            title: 'Analytics & Reporting',
            description:
               'Generate comprehensive reports on policies, premiums, claims, commissions, and more. Gain insights into your business performance with visual analytics dashboards.',
         },
      ],
      meta: {
         title: 'AKAS | The best Insurance, Sales and Revenues, Purchases and Expenses, and Accounting in Cambodia',
         description:
            "AKAS's Insurance Management System is a comprehensive solution designed to streamline insurance operations, improve customer service, and increase operational efficiency.",
         keywords:
            'Insurance Management System, AKAS, Insurance, Policy Management, Claims Processing, Insurance Software, Insurance Solution',
      },
      additionalFeatures: [
         {
            icon: '💰',
            title: 'Premium Calculation',
            description:
               'Automated premium calculations based on customizable factors and rating algorithms.',
         },
         {
            icon: '🔒',
            title: 'Secure Document Storage',
            description:
               'Securely store and manage all policy documents, claims files, and client communications.',
         },
         {
            icon: '📨',
            title: 'Automated Communications',
            description:
               'Set up automatic email and SMS notifications for renewals, premium payments, and claim updates.',
         },
         {
            icon: '⚙️',
            title: 'Customizable Workflows',
            description:
               'Create custom workflows for different policy types, client categories, and claim processes.',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Increased Operational Efficiency',
            description:
               'Automate routine tasks, reduce paperwork, and streamline workflows. Our Insurance Management System helps insurance professionals focus on providing value to clients rather than administrative tasks.',
         },
         {
            number: '02',
            title: 'Improved Customer Service',
            description:
               'Respond quickly to client inquiries with instant access to policy details and communication history. Provide faster claims processing and personalized service.',
         },
         {
            number: '03',
            title: 'Better Risk Management',
            description:
               'Make informed underwriting decisions with comprehensive client history and analytics. Identify trends and patterns to minimize risk exposure.',
         },
         {
            number: '04',
            title: 'Enhanced Regulatory Compliance',
            description:
               'Stay compliant with insurance regulations by maintaining accurate records and generating required reports automatically. Keep track of policy changes and documentation.',
         },
      ],
   },
   {
      id: 4,
      name: 'Revenues Management System',
      description:
         "AKAS's Revenues Management System is a comprehensive solution designed to help businesses track, analyze, and optimize their revenue streams. Our intuitive platform provides real-time visibility into sales performance, revenue forecasting, and financial analytics, enabling data-driven decisions that drive business growth.",
      images: ['/images/products/crm.jpeg'],
      backgroundImage: '/images/products/crm.jpeg',
      mainFeatures: [
         {
            icon: '💰',
            title: 'Revenue Tracking',
            description:
               'Monitor all revenue streams in real-time with comprehensive tracking capabilities. Track sales by product, service, customer segment, and sales channel to understand your revenue sources and optimize performance.',
         },
         {
            icon: '📊',
            title: 'Invoice Management',
            description:
               'Create, send, and manage professional invoices with automated payment tracking and reminders. Support for multiple currencies, payment methods, and customizable invoice templates to match your brand.',
         },
         {
            icon: '💳',
            title: 'Payment Processing',
            description:
               'Streamline payment collection with integrated payment gateway support. Accept multiple payment methods, automate payment reconciliation, and reduce payment processing time.',
         },
         {
            icon: '📝',
            title: 'Subscription Management',
            description:
               'Manage recurring revenue from subscriptions with automated billing, renewal tracking, and customer lifecycle management. Support for multiple subscription tiers and flexible billing cycles.',
         },
      ],
      meta: {
         title: 'AKAS | The best Revenues Management System, Sales and Financial Analytics in Cambodia',
         description:
            "AKAS's Revenues Management System helps businesses track, analyze, and optimize their revenue streams with real-time visibility and powerful analytics.",
         keywords:
            'Revenue Management, AKAS, Revenue Tracking, Invoice Management, Payment Processing, Revenue Analytics, Subscription Management, Financial Management',
      },
      additionalFeatures: [
         {
            icon: '🌐',
            title: 'Multiple Languages',
            description: 'English and Khmer (additional languages available)',
         },
         {
            icon: '💱',
            title: 'Multi-Currency Support',
            description:
               'Handle transactions in multiple currencies with automatic conversion',
         },
         {
            icon: '🔌',
            title: 'Integration Ready',
            description:
               'Connect with accounting software, CRM, and payment gateways',
         },
         {
            icon: '🔒',
            title: 'Secure & Compliant',
            description:
               'Enterprise-grade security with financial compliance standards',
         },
         {
            icon: '📱',
            title: 'Mobile Access',
            description:
               'Manage revenues on-the-go with mobile-responsive interface',
         },
         {
            icon: '🤖',
            title: 'Automated Workflows',
            description:
               'Automate invoicing, payment reminders, and revenue recognition',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Improved Cash Flow',
            description:
               'Accelerate revenue collection with automated invoicing, payment reminders, and streamlined payment processing. Reduce days sales outstanding and improve cash flow management.',
         },
         {
            number: '02',
            title: 'Revenue Visibility',
            description:
               'Gain complete visibility into all revenue streams with real-time dashboards and comprehensive reporting. Understand which products, services, and channels drive the most revenue.',
         },
         {
            number: '03',
            title: 'Better Financial Planning',
            description:
               'Make informed business decisions with accurate revenue forecasting and trend analysis. Plan budgets, allocate resources, and set realistic growth targets based on data-driven insights.',
         },
         {
            number: '04',
            title: 'Increased Efficiency',
            description:
               'Reduce manual work and errors with automated revenue processes. Free up your finance team to focus on strategic initiatives rather than administrative tasks.',
         },
      ],
   },
   {
      id: 5,
      name: 'Expense Management System',
      description:
         "AKAS's Expense Management System is a comprehensive procurement and spending solution that covers the entire purchase-to-pay cycle. From expense tracking and purchase requisitions to purchase orders, vendor management, and inventory control, our platform helps businesses manage all spending activities, control costs, and ensure policy compliance.",
      images: ['/images/products/crm.jpeg'],
      backgroundImage: '/images/products/crm.jpeg',
      mainFeatures: [
         {
            icon: '📱',
            title: 'Mobile Expense Capture',
            description:
               'Capture expenses on-the-go with mobile receipt scanning and automatic data extraction. Employees can submit expenses anytime, anywhere with photos of receipts that are automatically processed using OCR technology.',
         },
         {
            icon: '✅',
            title: 'Approval Workflows',
            description:
               'Create customizable multi-level approval workflows based on expense type, amount, and department. Automate routing, notifications, and escalations to ensure timely approvals and policy compliance.',
         },
         {
            icon: '💰',
            title: 'Reimbursement Processing',
            description:
               'Streamline reimbursement workflows with automated payment processing. Integrate with payroll or accounting systems for direct deposit reimbursements and comprehensive audit trails.',
         },
         {
            icon: '📝',
            title: 'Purchase Request Management',
            description:
               'Enable employees to submit purchase requests digitally with detailed item specifications, quantities, estimated costs, and justification. Configure multi-level approval workflows based on request amount, department, or budget availability.',
         },
         {
            icon: '📄',
            title: 'Purchase Order Management',
            description:
               'Generate professional purchase orders with automated item details, pricing, terms, and delivery schedules. Track purchase order status from creation through delivery and payment with 3-way matching between PO, goods receipt, and vendor invoice.',
         },
         {
            icon: '👥',
            title: 'Vendor & Supplier Management',
            description:
               'Maintain a comprehensive vendor database with contact information, payment terms, delivery performance, and pricing agreements. Monitor vendor performance with metrics like on-time delivery, quality ratings, and service levels.',
         },
      ],
      meta: {
         title: 'AKAS | The best Expense & Procurement Management System, Purchase Orders, Vendor Management in Cambodia',
         description:
            "AKAS's comprehensive Expense Management System covers the entire purchase-to-pay cycle including expense tracking, purchase requests, purchase orders, vendor management, and inventory control.",
         keywords:
            'Expense Management, AKAS, Expense Tracking, Purchase Request, Purchase Order, Procurement, Vendor Management, Inventory Management, Cost Control, Expense Reports',
      },
      additionalFeatures: [
         {
            icon: '🌐',
            title: 'Multiple Languages',
            description: 'English and Khmer (additional languages available)',
         },
         {
            icon: '💱',
            title: 'Multi-Currency Support',
            description:
               'Handle expenses in multiple currencies with automatic conversion rates',
         },
         {
            icon: '🔌',
            title: 'Integration Ready',
            description:
               'Connect with accounting software, ERP, and payment systems',
         },
         {
            icon: '📸',
            title: 'OCR Technology',
            description: 'Automatic receipt scanning and data extraction',
         },
         {
            icon: '📱',
            title: 'Mobile App',
            description:
               'Submit and approve expenses from anywhere on iOS and Android',
         },
         {
            icon: '🔒',
            title: 'Secure Storage',
            description: 'Encrypted document storage with audit trails',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Reduced Processing Time',
            description:
               'Automate expense submission, approval, and reimbursement processes. Reduce manual work by up to 80% and speed up reimbursement cycles, improving employee satisfaction.',
         },
         {
            number: '02',
            title: 'Better Cost Control',
            description:
               'Gain real-time visibility into company spending with comprehensive analytics and reporting. Identify spending trends, enforce budgets, and make informed decisions to control costs.',
         },
         {
            number: '03',
            title: 'Enhanced Compliance',
            description:
               'Ensure policy compliance with automated validation and approval workflows. Reduce fraudulent claims, enforce spending limits, and maintain complete audit trails for regulatory compliance.',
         },
         {
            number: '04',
            title: 'Improved Employee Experience',
            description:
               'Simplify expense reporting for employees with mobile receipt capture and automated data entry. Provide faster reimbursements and transparent tracking of expense report status.',
         },
      ],
   },
   {
      id: 6,
      name: 'Inventory Management System',
      description:
         "AKAS's Inventory Management System provides real-time visibility and control over your stock levels. From warehouse management to stock movements and reorder automation, our platform helps you optimize inventory, reduce costs, and ensure product availability.",
      images: ['/images/products/crm.jpeg'],
      backgroundImage: '/images/products/crm.jpeg',
      mainFeatures: [
         {
            icon: '📦',
            title: 'Stock Management',
            description:
               'Track inventory levels in real-time across multiple warehouses and locations. Monitor stock movements, adjustments, and transfers with complete traceability and audit trails.',
         },
         {
            icon: '🔄',
            title: 'Automated Reordering',
            description:
               'Set reorder points and safety stock levels for automatic purchase requisition generation. Prevent stockouts and optimize inventory levels with intelligent reorder recommendations.',
         },
         {
            icon: '📱',
            title: 'Barcode Scanning',
            description:
               'Streamline receiving, picking, and stock takes with mobile barcode scanning. Reduce errors and speed up warehouse operations with real-time inventory updates.',
         },
         {
            icon: '📊',
            title: 'Inventory Analytics',
            description:
               'Analyze inventory turnover, carrying costs, and stock aging. Identify slow-moving items, optimize stock levels, and make data-driven inventory decisions.',
         },
         {
            icon: '🏭',
            title: 'Multi-Location Support',
            description:
               'Manage inventory across multiple warehouses, stores, or distribution centers. Track stock movements between locations and optimize inventory distribution.',
         },
         {
            icon: '💰',
            title: 'Valuation & Costing',
            description:
               'Calculate inventory value using FIFO, LIFO, or weighted average methods. Track cost of goods sold and maintain accurate financial records for accounting integration.',
         },
      ],
      meta: {
         title: 'AKAS | The best Inventory Management System, Warehouse and Stock Control in Cambodia',
         description:
            "AKAS's Inventory Management System provides real-time stock visibility, automated reordering, and warehouse optimization.",
         keywords:
            'Inventory Management, AKAS, Stock Control, Warehouse Management, Barcode Scanning, Inventory Tracking, Stock Management',
      },
      additionalFeatures: [
         {
            icon: '🌐',
            title: 'Multiple Languages',
            description: 'English and Khmer (additional languages available)',
         },
         {
            icon: '📱',
            title: 'Mobile App',
            description: 'iOS and Android apps for warehouse operations',
         },
         {
            icon: '🏷️',
            title: 'Batch & Serial Tracking',
            description: 'Track items by batch number or serial number',
         },
         {
            icon: '📅',
            title: 'Expiry Management',
            description: 'Monitor expiration dates and receive alerts',
         },
         {
            icon: '🔌',
            title: 'System Integration',
            description:
               'Integrate with sales, purchasing, and accounting systems',
         },
         {
            icon: '📈',
            title: 'Demand Forecasting',
            description:
               'Predict future inventory needs based on historical data',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Reduced Costs',
            description:
               'Optimize inventory levels to reduce carrying costs and minimize capital tied up in stock. Prevent overstocking and reduce waste from obsolete inventory.',
         },
         {
            number: '02',
            title: 'Improved Accuracy',
            description:
               'Eliminate manual counting errors with barcode scanning and automated tracking. Maintain accurate inventory records for better financial reporting and decision-making.',
         },
         {
            number: '03',
            title: 'Better Availability',
            description:
               'Ensure product availability with automated reordering and safety stock management. Reduce stockouts and improve customer satisfaction.',
         },
         {
            number: '04',
            title: 'Enhanced Efficiency',
            description:
               'Streamline warehouse operations with mobile apps, barcode scanning, and automated processes. Reduce labor costs and improve productivity.',
         },
      ],
   },

   {
      id: 7,
      name: 'The best Clinic Management System in Cambodia',
      description:
         "AKAS's Clinic Management System is an intuitive, user-friendly, multilingual, web-based application accessible from various devices, including PCs, laptops, Macs, and tablets, using browsers like Internet Explorer, Firefox, Chrome, and Safari.s",

      // images: [
      //    '/images/products/clinic-bg.gif',
      // ],
      backgroundImage: '/images/products/clinic-bg.gif',
      mainFeatures: [
         {
            icon: '💻',
            title: 'Queue Management',
            description:
               'Manage patient queues efficiently with real-time tracking and automated scheduling. Reduce wait times, improve patient flow, and enhance overall clinic operations.',
            images: [
               '/images/products/clinic-queue.png',
            ],
         },
         {
            icon: '📅',
            title: 'Appointment Scheduling',
            description:
               'Create and manage patient appointments with customizable scheduling options. Integrate with electronic health records (EHR) systems for seamless patient scheduling and tracking.',
            images: [
               '/images/products/clinic-appointment.png',
            ],
         },
         {
            icon: '📊',
            title: 'Electronic Health Records (EHR)',
            description:
               'Store and manage patient medical records, including diagnoses, treatments, medications, and test results. Integrate with electronic health records (EHR) systems for seamless patient scheduling and tracking.',
            images: [
               '/images/products/clinic-ehr.png',
            ],
         },
         {
            title: 'Consultation and Prescription',
            description:
               'Provide comprehensive consultation services with electronic health records (EHR) systems for seamless patient scheduling and tracking.',
            images: [
               '/images/products/clinic-consultation.png',
               '/images/products/clinic-prescription.png',
            ],
         },
         {
            title: 'Disensary Management',
            description:
               'Manage disensary inventory levels in real-time across multiple clinics and locations. Monitor stock movements, adjustments, and transfers with complete traceability and audit trails.',
            images: [
               '/images/products/clinic-dispensary.png',
            ],
         },
         {
            title: 'Invoicing and Payment',
            description:
               'Generate invoices and receipts for patient consultations and treatments. Live process payments securely through various payment methods like KHQR',
            images: [
               '/images/products/clinic-payment.png',
            ],
         },
         
         
      ],
      meta: {
         title: 'AKAS | The best Clinic Management System in Cambodia',
         description:
            "AKAS's Clinic Management System is an intuitive, user-friendly, multilingual, web-based application accessible from various devices, including PCs, laptops, Macs, and tablets, using browsers like Internet Explorer, Firefox, Chrome, and Safari. ",
         keywords:
            'Clinic Management System, AKAS, Clinic Management, Clinic Management System, Clinic Management Software, Clinic Management Solution, Clinic Management System, Clinic Management System, Clinic Management System',
      },
      additionalFeatures: [
         
         {
            icon: '🌐',
            title: 'Multiple languages',
            description: 'English and Khmer (can be added more)',
         },
         {
            icon: '📁',
            title: 'Document Management',
            description: 'Store and manage patient medical records, including diagnoses, treatments, medications, and test results',
         },
         {
            icon: '⚙️',
            title: 'Fully customizable',
            description: 'Allow users to customize the system with custom fields and reports',
         },
         {
            icon: '🔔',
            title: 'Notifications',
            description: 'Live notifications for queue management, appointment scheduling, and inventory management',
         },
         {
            icon: '📝',
            title: 'Logging',
            description: 'Track user activity and system logs for audit and compliance',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Increased Efficiency',
            description:
               'Streamline Clinic processes, reduce paperwork, and automate repetitive tasks. Our Clinic Management System helps Clinic professionals focus on strategic initiatives rather than administrative work.',
         },
         {
            number: '02',
            title: 'Better Decision Making',
            description:
               'Access real-time data and analytics to make informed Clinic decisions. Monitor key metrics such as employee turnover, productivity, and performance.',
         },
         {
            number: '03',
            title: 'Enhanced Clinic Experience',
            description: 'Provide self-service options for patients to manage their appointments, view their medical records, and access clinic resources, leading to higher satisfaction and engagement.',
         },
         {
            number: '04',
            title: 'Compliance Management',
            description:
               'Stay compliant with labor laws and regulations by maintaining accurate records and generating required reports automatically.',
         },
      ],
      // videos: [
         
      //    // {
      //    //    title: 'Customization feature',
      //    //    youtubeId: 'RlB4MXPjYXs',
      //    //    description: 'Customization feature Demo',
      //    // },
      // ],
   },
   {
      id: 8,
      name: 'The best Point of Sales (POS) System in Cambodia',
      description:
         "AKAS's Point of Sales (POS) System is an intuitive, multilingual application available on Windows, macOS, and Android. Install native desktop and tablet apps — so your team can sell from the devices and operating systems they already use.",

      images: [
         '/images/products/pos.jpeg',
      ],
      backgroundImage: '/images/products/pos.jpeg',
      mainFeatures: [
         {
            icon: '🖥️',
            title: 'Multi-OS Native Apps',
            description:
               'Download and run AKAS POS on Windows, macOS, and Android. Use the same checkout experience on store PCs, Macs, and tablets without being tied to a single platform.',
         },
         {
            icon: '💻',
            title: 'Sales Management',
            description:
               'Manage sales transactions, inventory, and customer data with ease. Our POS system integrates with your existing business tools for seamless operations.',
         },
         {
            icon: '🧾',
            title: 'Checkout & Receipts',
            description:
               'Speed up checkout with barcode scanning, hold and resume carts, and printable or emailed receipts. Reconcile cash drawers and keep sales moving during busy periods.',
         },
         {
            icon: '📦',
            title: 'Inventory Sync',
            description:
               'Track stock levels in real time as items are sold. Keep product, pricing, and availability aligned across POS terminals and your back-office systems.',
         },
      ],
      meta: {
         title: 'AKAS | The best Point of Sales (POS) System in Cambodia',
         description:
            'AKAS POS runs on Windows, macOS, and Android with native apps and browser access. Sell in-store with multilingual support, inventory sync, and integrated checkout.',
         keywords:
            'Point of Sales, POS, AKAS, POS System, Windows POS, macOS POS, Android POS, Retail POS, Cambodia POS',
      },
      additionalFeatures: [
         
         {
            icon: '🌐',
            title: 'Multiple languages',
            description: 'English and Khmer (additional languages can be added)',
         },
         {
            icon: '⚡',
            title: 'Offline-capable',
            description: 'Keep selling during connectivity drops and sync transactions when back online.',
         },
         {
            icon: '🔌',
            title: 'Hardware integrations',
            description: 'Connect barcode scanners, receipt printers, and cash drawers for a complete checkout setup.',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'Use the OS you already have',
            description:
               'Deploy on Windows tills, Mac-based counters, or Android tablets without buying new hardware or switching ecosystems.',
         },
         {
            number: '02',
            title: 'Faster checkout',
            description:
               'Reduce queue times with streamlined sales flows, barcode scanning, and quick receipt printing or emailing.',
         },
         {
            number: '03',
            title: 'Accurate inventory',
            description:
               'Update stock automatically with every sale so your team always knows what is available on the floor.',
         },
         {
            number: '04',
            title: 'Consistent experience',
            description:
               'Give cashiers and managers the same POS interface across operating systems, stores, and devices.',
         },
         
      ],
   }
];
